/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.getSpace'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  space: /*#__PURE__*/ l.string(),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  uri: /*#__PURE__*/ l.string(),
  authorityDid: /*#__PURE__*/ l.string({ format: 'did' }),
  ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
  kind: /*#__PURE__*/ l.string<{ knownValues: ['account', 'community'] }>(),
  visibility: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: [
        'public',
        'protected',
        'restricted',
        'invite-only',
        'private',
      ]
    }>(),
  ),
  name: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  description: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Return permissioned-space metadata only when the authenticated viewer may discover it. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
